import { CART_ITEM_QUANTITY_UPDATE_REQUEST } from '../actionTypes/CartActionTypes';

export const itemQuantityUpdate = (params) => ({
    type: CART_ITEM_QUANTITY_UPDATE_REQUEST,
    payload: params,
});

export default { itemQuantityUpdate };
